<template>
  <div class="Fuell-Table--row">
    <div
      class="Fuell-Table--item clickable"
      @click="editCustomField"
    >{{ transactionFieldName }}</div>
    <div
      class="Fuell-Table--item clickable"
      @click="editCustomField"
      v-tooltip="transactionFieldTags"
    >
      <span class="ellipsis">{{ transactionFieldTags }}</span>
    </div>
    <div
      class="Fuell-Table--item clickable"
      @click="editCustomField"
      v-tooltip="transactionFieldIncludeInTransactionType"
    >
      <span class="ellipsis">{{ transactionFieldIncludeInTransactionType }}</span>
    </div>

    <div
      class="Fuell-Table--item clickable"
      @click="editCustomField"
      v-tooltip="transactionFieldIncludedInBudgets"
    >
      <span class="ellipsis">{{ transactionFieldIncludedInBudgets }}</span>
    </div>
    <div class="Fuell-Table--item Fuell-Table--options">
      <dropdown
      :closeOnClickInside="false"
      >
        <div
          class="clickable"
          role="button"
          @click="editCustomField"
        >{{$t('ACTION_EDIT')}}</div>
        <div
          class="clickable"
          role="button"
          @click="handleDeleteCustomField"
        >{{$t('ACTION_REMOVE')}}</div>
      </dropdown>
    </div>
    <confirm-modal
      v-if="showConfirmModal"
      :title="'ACTION_REMOVE'"
      :open.sync="showConfirmModal"
      :acceptText="'ACTION_REMOVE'"

      @accept="deleteCustomField"
      @dismiss="dismissDelete"
    ></confirm-modal>
  </div>
</template>

<script>

import Dropdown from '@/components/Commons/Dropdown'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'TransactionFieldsTableRow',
  components: { Dropdown, ConfirmModal },
  props: {
    transactionField: {
      type: Object
    }
  },
  data () {
    return {
      showConfirmModal: false
    }
  },
  computed: {
    transactionFieldName () {
      return this.transactionField && this.transactionField.name
        ? this.transactionField.name
        : ''
    },
    transactionFieldTags () {
      return this.transactionField && this.transactionField.tags.length > 0
        ? this.transactionField.tags.map(el => el.name).join()
        : ''
    },
    transactionFieldIncludedInBudgets () {
      if (this.transactionField.includeIn === 'ALL_BUDGETS') {
        return this.$t(
          'company_create_transaction_field_include_in_all_budgets'
        )
      }
      return this.transactionField.includeBudgets.length > 0
        ? this.transactionField.includeBudgets.map(el => el.name).join()
        : ''
    },
    transactionFieldIncludeInTransactionType () {
      return this.transactionField.includeInTransactionTypes.map(el => this.$t(el)).join()
    }
  },
  methods: {
    editCustomField () {
      this.$emit('editCustomField', this.transactionField.id)
    },
    handleDeleteCustomField () {
      this.showConfirmModal = true
    },
    deleteCustomField (receipt) {
      this.$emit('deleteCustomField', this.transactionField.id)
    },
    dismissDelete () {
      this.receiptToDelete = null
    }
  }
}
</script>
